// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nCVU","label":"styles_label__3HW6v"};